export default {
    getTagsFromInCache(state) {
        return state.tags;
    }
};
